export default "__VITE_ASSET___VX084ey__"